import { render, staticRenderFns } from "./ModalEditarResponseHeadersRequisicao.vue?vue&type=template&id=7c80b5e4&scoped=true"
import script from "./ModalEditarResponseHeadersRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarResponseHeadersRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarResponseHeadersRequisicao.vue?vue&type=style&index=0&id=7c80b5e4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80b5e4",
  null
  
)

export default component.exports